import { COLOUR_FACET_GROUP } from "../../nonActionConstants";

export const getHasMoreColours = ({ facetGroupings = [] }) =>
  !!facetGroupings?.some(facetGroup => facetGroup.type === COLOUR_FACET_GROUP);
